import styled from 'styled-components';
import { BlockContentContainer } from 'common/components/TouchpointEditor/components/TouchpointContainer';
import { mediaMaxWidth } from 'common/styles/breakpoints';

export const SessionsBlockContentContainer = styled(BlockContentContainer)`
    padding: 3.5rem 4rem;
    ${mediaMaxWidth.medium`
        padding: 3.5rem 1rem;
    `}
`;

export const VirtualContentBlockContentContainer = styled(BlockContentContainer)`
    ${mediaMaxWidth.medium`
    padding: 1rem 1rem 2rem 1rem;
    `}
`;

export const ActiveSessionGrid = styled.div`
    display: grid;
    grid-template-columns: 2fr 1fr;
    grid-gap: 1.5rem;
    padding: 2.5rem 4rem;

    ${mediaMaxWidth.medium`
        padding: 2rem 1rem 3.5rem;
        grid-template-columns: 1fr;
    `}
`;

export const SpeakerInformationContainer = styled.div`
    display: flex;
    flex-direction: column;
    align-items: flex-end;
    gap: 1rem;

    ${mediaMaxWidth.medium`
        align-items: flex-start;
    `}
`;
